const authors = [
    {
        name: 'Lunaticsatoshi',
        imageUrl: 'Profile.jpg',
        bio: 'A happy react developer with a knack for learning something new every day',
        github: 'https://github.com/Lunaticsatoshi',
        linkedIn: 'https://www.linkedin.com/in/sudeep-deysarker-074a12190',
    }
]

module.exports = authors;